import { BaseDialog } from "./dialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";
import { InputWithAlert } from "../ui/input-with-alert";
import { DatePicker } from "../ui/date-picker";
import { useNavigate } from 'react-router-dom';
import { createZeroOutCorrection } from "@/service/weexpertService";
import { useMutation } from "react-query";
import { toast } from "../ui/use-toast";
import { format } from "date-fns";
import ClearIcon from '@mui/icons-material/Clear';

export default function InvoiceCorrectionZeroPopup({ id, invoiceId, className }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [correctionReason, setCorrectionReason] = useState("");
  const [issueDate, setIssueDate] = useState(new Date());
  const [inputChecked, setInputChecked] = useState(false);

  const mutation = useMutation({
    mutationFn: () => {
      const formattedDate = format(issueDate, 'yyyy-MM-dd');
      return createZeroOutCorrection(id, correctionReason, formattedDate);
    },
    onSuccess: (response) => {
      toast({
        title: t("invoices:zero_out_created"),
      });
      setOpen(false);
      const newInvoiceId = response.data?.id;
      if (newInvoiceId) {
        navigate(`/admin/invoices/details/${newInvoiceId}`);
      }
    },
    onError: () => {
      toast({
        title: t("invoices:zero_out_error"),
        variant: "destructive",
      });
    },
  });

  const handleZeroOut = () => {
    setInputChecked(true);
    if (correctionReason.length >= 10) {
      mutation.mutate();
    }
  };

  const isValid = correctionReason.length >= 10;
  const showError = inputChecked && !isValid;

  return (
    <BaseDialog
      dialogTitle={`${t('invoices:zero_out_title')}: ${invoiceId}`}
      buttonText={t("invoices:button_zero_out")}
      open={open}
      setOpen={setOpen}
      className={className}
      icon={<ClearIcon fontSize="small" className="mr-1" />}
    >
      <div className="max-w-[500px] flex flex-col items-end">
        <div className="w-full py-4 bg-grayLightMainBg">
          <div className="pb-4 text-gray-600">
            {t("invoices:zero_out_confirm")}
          </div>

          <div className="pb-4">
            <InputWithAlert
              label={`${t("invoices:correction_reason")} *`}
              value={correctionReason}
              onChange={(e) => setCorrectionReason(e.target.value)}
              placeholder={t("invoices:correction_reason_placeholder")}
              error={showError}
              errorMessage={t("invoices:correction_reason_min_length")}
              inputClassName={'h-12 mt-2 mb-4 bg-white'}
            />
          </div>

          <DatePicker
            label={t("invoices:date_of_creation")}
            date={issueDate}
            setDate={(date) => {
              if (!date) return;
              setIssueDate(date);
            }}
            inputClassName={'h-12 text-base mb-4'}
          />
        </div>

        <Button
          disabled={mutation.isLoading}
          onClick={handleZeroOut}
        >
          {t("invoices:button_zero_out")}
        </Button>
      </div>
    </BaseDialog>
  );
}
